import * as React from 'react';
import { RouteComponentProps } from 'react-router';

interface EndUserLicenceAgreement {
    loading: Boolean;
}

export class EndUserLicenceAgreementData extends React.Component<RouteComponentProps<{}>, EndUserLicenceAgreement> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false
        };
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div>
                <h1>End User Licence Agreement</h1>
                <br></br>
                <p>
                    This End-User License Agreement ("EULA") is a legal agreement between you and Super Safe Hire.
                </p>
                <p>
                    This EULA agreement governs your acquisition and use of our Dash software ("Software") directly from Super Safe Hire.
                </p>
                <p>
                    Please read this EULA agreement carefully before using the Dash software. 
                </p>
                <p>
                    If you are entering into this EULA agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity and its affiliates to these terms and conditions. If you do not have such authority or if you do not agree with the terms and conditions of this EULA agreement, do not use the Software, and you must not accept this EULA agreement.
                </p>
                <p>
                    This EULA agreement shall apply only to the Software supplied by Super Safe Hire herewith regardless of whether other software is referred to or described herein. The terms also apply to any Super Safe Hire updates, supplements, Internet-based services, and support services for the Software, unless other terms accompany those items on delivery. If so, those terms apply. This EULA was created for Dash.
                </p>
                <p>
                    You are permitted to use the Dash software (for example a PC, laptop, mobile or tablet) under your control. You are responsible for ensuring your device meets the minimum requirements of the Dash software.
                </p>
                <p>
                    You are not permitted to:
                    <ul>
                        <li>Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the Software nor permit the whole or any part of the Software to be combined with or become incorporated in any other software, nor decompile, disassemble or reverse engineer the Software or attempt to do so</li>
                        <li>Reproduce, copy, distribute, resell or otherwise use the Software for any commercial purpose</li>
                        <li>Allow any third party to use the Software on behalf of or for the benefit of any third party</li>
                        <li>Use the Software in any way which breaches any applicable local, national or international law</li>
                        <li>Use the Software for any purpose that Super Safe Hire considers is a breach of this EULA agreement</li>
                    </ul>
                </p>
                <h3>
                    Intellectual Property and Ownership
                </h3>
                <p>
                    Super Safe Hire shall at all times retain ownership of the Software as originally used by you and all subsequent uses of the Software by you. The Software (and the copyright, and other intellectual property rights of the Software, including any modifications made thereto) are and shall remain the property of Super Safe Hire.
                </p>
                <p>
                    Super Safe Hire reserves the right to grant licences to use the Software to third parties.
                </p>
                <h3>
                    Termination
                </h3>
                <p>
                    This EULA agreement is effective from the date you are registered to use the Software and shall continue until terminated. You may terminate it at any time upon written notice to Super Safe Hire.
                </p>
                <p>
                    It will also terminate immediately if you fail to comply with any term of this EULA agreement. Upon such termination, the license granted by this EULA agreement will be immediately terminated and you agree to stop all access and use of the Software.
                </p>
                <h3>
                    Governing Law
                </h3>
                <p>
                    This EULA agreement, and any dispute arising out of or in connection with this EULA agreement, shall be governed by and construed in accordance with the laws of Australia.
                </p>
            </div>
        );

    }

};